import { render } from "./WorkAreaDetailsPage.vue?vue&type=template&id=5e311ed4"
import script from "./WorkAreaDetailsPage.vue?vue&type=script&lang=ts"
export * from "./WorkAreaDetailsPage.vue?vue&type=script&lang=ts"
script.render = render

export default script